// extracted by mini-css-extract-plugin
module.exports = {"component":"index_component__2L19f","uploadButton":"index_uploadButton__1uZgi","uploadButton_tip":"index_uploadButton_tip__2BEsw","tip":"index_tip__2WuAz"};